import React from "react";
import { StyledFieldsContainer } from "./styles";
import { ReactComponent as ArrowLeftImage } from "./assets/arrow-left.svg";
import { Card, CardContent } from "../ui/shadcn/card";
import StyledCardAction from "../ui/styled/styled-card-action";
import { Button } from "../ui/buttons/button";
import { FieldValues, FormProvider, UseFormReturn } from "react-hook-form";

interface FormContainerProps<T extends FieldValues, Y> {
  onSubmit: (values: Y) => Promise<void>;
  onBack?: () => void;
  submitLabel?: string;
  submittingLabel?: string;
  disabled?: boolean;
  children: React.ReactNode;
  formContainerFooter?: React.ReactNode;
  methods: UseFormReturn<T, any, T>;
}

const FormContainer = <T extends FieldValues, Y>({
  onSubmit,
  onBack,
  submitLabel = "Enviar",
  submittingLabel = "Enviando...",
  disabled = false,
  children,
  formContainerFooter,
  methods,
}: FormContainerProps<T, Y>) => {
  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <form
        className="w-full"
        onSubmit={handleSubmit((data) => onSubmit(data as unknown as Y))}
      >
        {onBack && (
          <ArrowLeftImage
            className="w-16 h-16 py-4 cursor-pointer"
            onClick={onBack}
          />
        )}
        <Card className="px-2 py-4 w-full max-w-md mx-auto mt-10">
          <CardContent className="pt-3 pb-4">
            <StyledFieldsContainer>{children}</StyledFieldsContainer>
          </CardContent>
          <StyledCardAction>
            <Button
              className="bg-[#0c2856] text-white w-full hover:bg-[#091831ff] cursor-pointer"
              type="submit"
              disabled={disabled}
              aria-busy={disabled}
            >
              {disabled ? submittingLabel : submitLabel}
            </Button>
            {formContainerFooter && formContainerFooter}
          </StyledCardAction>
        </Card>
      </form>
    </FormProvider>
  );
};

export default FormContainer;
